import {LeftOutlined} from '@ant-design/icons';
import {Badge} from '@ds/components';
import {cn} from '@ds/helpers';

type ProfileItemProps = {
  title: string;
  icon: React.ReactNode;
  status?: 'active' | 'inactive';
  onClick: () => void;
  isLogoutItem?: boolean;
  hasBadge?: boolean;
  loading?: boolean;
};

const ProfileItem: React.FC<ProfileItemProps> = ({
  title,
  icon,
  status,
  onClick,
  isLogoutItem = false,
  hasBadge = false,
  loading = false
}) => {
  return (
    <button
      type="button"
      className="flex h-14 w-full items-center justify-between text-start disabled:cursor-wait disabled:opacity-60"
      disabled={loading}
      onClick={onClick}
    >
      <span className="flex min-w-0 items-center gap-2">
        <span className="flex size-6 shrink-0 items-center justify-center text-xl text-gray-07">
          {icon}
        </span>
        <span
          className={cn(
            'truncate text-body-sm text-gray-08',
            isLogoutItem && 'text-destructive'
          )}
        >
          {title}
        </span>
        {hasBadge && (
          <Badge variant="status" color="primary" size="sm">
            جدید
          </Badge>
        )}
        {status && (
          <span
            className={cn(
              'flex h-6 items-center rounded-[10px] border px-3 text-caption-emphasis',
              status === 'active'
                ? 'border-green-rich/20 bg-green-rich/8 text-green-rich/70'
                : 'border-destructive/20 bg-destructive/8 text-destructive/70'
            )}
          >
            {status === 'active' ? 'فعال' : 'غیرفعال'}
          </span>
        )}
      </span>
      {!isLogoutItem && <LeftOutlined className="shrink-0  text-gray-06" aria-hidden />}
    </button>
  );
};

export default ProfileItem;
